<template>
	<div id="app">
		<div ref="CS" v-html='content'></div>
	</div>
</template>

<script>
	import { getAgreement } from './agreements'
	import { agreementConfig } from './config/agreement-config'
	import { matchBrand } from './config/brands'
	import { fillTemplate } from './utils/render'
	import { hasLocale } from './i18n'

	const AGREEMENT_TYPES = ['user', 'privacy', 'cancel', 'permission', 'member']

	// 解析 URL 查询参数（?type=user&lang=zh-CN&appname=xxx）
	// 同名参数会全部保留在 lists 中，便于兼容 ?type=user&type=蚕猫ai 这类写法
	function parseQuery() {
		const params = {}
		const lists = {}
		const queryString = location.search.split('?')[1]
		if (!queryString) return { params, lists }
		queryString.split('&').forEach(part => {
			const idx = part.indexOf('=')
			const key = decodeURIComponent(idx > -1 ? part.slice(0, idx) : part)
			const value = idx > -1 ? decodeURIComponent(part.slice(idx + 1)) : ''
			if (!key) return
			;(lists[key] = lists[key] || []).push(value)
			// 同名参数取最后一个，保持与旧逻辑一致
			params[key] = value
		})
		return { params, lists }
	}

	// 从 type 参数的全部取值里区分协议类型与品牌名
	function pickType(values) {
		const list = (values || []).filter(Boolean).map(v => String(v).trim())
		const type = list.find(v => AGREEMENT_TYPES.indexOf(v.toLowerCase()) > -1) || 'user'
		const brand = list.find(v => AGREEMENT_TYPES.indexOf(v.toLowerCase()) === -1)
		return { type: type.toLowerCase(), brand }
	}

	export default {
		name: 'app',
		components: {},
		data() {
			return {
				content: ''
			}
		},
		created() {
			const { params, lists } = parseQuery()
			const { type, brand: brandFromType } = pickType(lists.type)

			const lang = params.lang || 'zh-CN'
			// 品牌（公司）标识优先级：appname > app > brand > 重复 type 里的非协议类型值
			const brandKey = params.appname || params.app || params.brand || brandFromType

			// 1. 取本地协议内容（每个协议类型一个文件夹，loader 返回 { html, locale }）
			//    getAgreement 内部已按 brandKey 覆盖 common 里的公司主体信息
			const { html, locale } = getAgreement(lang, type, brandKey)
			if (!html) {
				this.content = '未找到对应的协议内容'
				return
			}

			// 2. 未在 brands.js 中登记的品牌，沿用原有兜底：
			//    产品名优先级：URL 参数 > 语言文件自带的 common.appName > 配置里的默认名
			//    未注册语言无语言文件、会回退 zh-CN 文案，此时改用配置，避免中文品牌名外泄
			let common = locale.common || {}
			if (!matchBrand(brandKey)) {
				const isChinese = lang.indexOf('zh') === 0
				const configName = isChinese
					? agreementConfig.productName
					: (agreementConfig.productNameEn || agreementConfig.productName)
				const localeName = hasLocale(lang) ? common.appName : ''
				const productName = brandKey || localeName || configName
				if (productName && productName !== common.appName) {
					common = Object.assign({}, common, { appName: productName })
				}
			}
			this.content = fillTemplate(html, Object.assign({}, locale, { common }))

			// 3. 从渲染后的内容中提取 <title> 设置页面标题
			this.$nextTick(() => {
				const csElement = this.$refs.CS
				if (!csElement) return
				const titleTag = csElement.querySelector('title')
				if (titleTag) {
					document.title = titleTag.textContent
				}
			})
		}
	}
</script>

<style>
	.text {
		padding: 20rpx 30rpx;
		font-size: 32rpx;
		white-space: pre-wrap;
		text-align: left;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #2c3e50;
	}
</style>
